import { IInfluencer } from '../../../redux/buzzbridge/types';
import { isCreatorVerified, primaryHandle } from '../utils/creatorProfileHelpers';
import { resolveInfluencerDisplayAvatarUrl } from '../../../utils/influencerSocialAvatar';
import { CreatorProfileHeroIdentity } from './CreatorProfileHeroIdentity';

export interface ProfileHeaderProps {
    influencer: IInfluencer;
    onEdit?: () => void;
}

export function ProfileHeader({ influencer, onEdit }: ProfileHeaderProps) {
    const place =
        influencer.location?.short_name ||
        influencer.location?.description ||
        influencer.country ||
        influencer.nationality;
    const subtitle = [influencer.bio?.trim(), place].filter(Boolean).join(' • ');

    return (
        <CreatorProfileHeroIdentity
            name={influencer.name || 'Creator'}
            handle={primaryHandle(influencer)}
            verified={isCreatorVerified(influencer)}
            avatarUrl={resolveInfluencerDisplayAvatarUrl(influencer)}
            subtitle={subtitle || undefined}
            onEdit={onEdit}
        />
    );
}
